<div class="p-10 m-20" >
  <ion-row>
    <ion-col size="12">
      <form [formGroup]="upcomingTrainingForm">
        <ion-row class="align-items-center">
          <!-- Search Field -->
          <ion-col size="3">
            <mat-form-field class="mat-height40 mat-input-style w-100">
              <mat-icon matPrefix>search</mat-icon>
              <input matInput type="search" placeholder="Search" formControlName="searchTerm">
            </mat-form-field>
          </ion-col>
  
          <!-- Program Selection -->
          <ion-col size="3">
            <mat-form-field class="mat-height40 mat-input-style w-100">
              <mat-select placeholder="Select Program" formControlName="selectedProgram">
                <mat-option *ngFor="let program of programList" [value]="program">
                  {{ program }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
  
          <!-- Download Button -->
         
        <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="" class=" pl-10 pt-10 pr-10">
          <div class="center-content float-right">
            <div>
              <button  class="mr-10 Download fs-16 font_semibold  float-right center-content mr-5">
                <img src="././assets/icon/yellowdownload.png" class="downIcon">Download
              </button>
            </div>
          </div>
        </ion-col>
        </ion-row>
      </form>
    </ion-col>
  </ion-row>
  


  
   <div class="table-container">
     <table class="custom-table rounded-header">
        <thead>
         <tr>
           
            <th *ngFor="let item of tableHeaders"
             class="fs-14 font_bold cl-black">
             <div class=" verticle-center justify-content-space-between icon-style">
               {{ item?.label }}
             </div>
            </th>
         </tr>
       </thead>
         <tbody class="bg-white">
           <tr *ngFor="let program of trainingPrograms">
             
             <td>{{ program.trainingType }}</td>
             <td>{{ program.title }}</td>
             <td>{{ program.code }}</td>
             <td><a [href]="program.lmsLink" target="_blank">link</a></td>
             <td>{{ program.startDate }}</td>
             <td>{{ program.endDate }}</td>
             <td>{{ program.category }}</td>
             <td>{{ program.department }}</td>
             <td>{{ program.band }}</td>
             <td>{{ program.grade }}</td>
             <td>{{ program.programDays }}</td>
             <td>{{ program.budgetCost }}</td>
             <td>{{ program.actualCost }}</td>
             <td>{{ program.objective }}</td>

           </tr>
         </tbody>
     </table>
   </div>
 </div>

